import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-play',
  templateUrl: './icon-play.component.html',
  styleUrls: ['./icon-play.component.scss']
})
export class IconPlayComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
